export default __webpack_public_path__ + "static/media/spinner.d304d823.svg";